import { render, staticRenderFns } from "./DashboardChartMeasurements.vue?vue&type=template&id=4c65ba63&scoped=true&"
import script from "./DashboardChartMeasurements.vue?vue&type=script&lang=js&"
export * from "./DashboardChartMeasurements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c65ba63",
  null
  
)

export default component.exports